import moment from "moment";

const monthFormat = "MMM YYYY";

const getDateTabs = (currentTabs, request, monthsToShowPre=1, monthsToShowPost=5) => {

    let firstMonth;
    if (currentTabs === undefined)
        firstMonth = moment();
    else {
        firstMonth = moment(currentTabs.values[monthsToShowPre].value, monthFormat);
    }

    if (request !== undefined) {
        firstMonth = moment(firstMonth).add(request, "months");
    }

    let values = [];
    let tabs = [];
    let tabValue = -1;

    for (let i = -monthsToShowPre; i <= monthsToShowPost; i++) {
        const date = moment(firstMonth).add(i, "months");
        const month = date.format(monthFormat);
        const tab = {label: month, value: ++tabValue};
        values.push({month: date.month() + 1, year: date.year() , value: month});
        tabs.push(tab);
    }

    return {values: values, tabs: tabs};
}


export {
    getDateTabs
}